var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "color-bg-fff border-radius-5 padding-x-10 padding-top-20 padding-bottom-10 margin-bottom-20",
    },
    [
      _c(
        "div",
        { staticClass: "flex-start" },
        [
          _c("img", {
            staticClass: "margin-x-20 margin-bottom-10",
            staticStyle: { width: "60px", height: "60px" },
            attrs: { src: require("./static/icon_user_headimg.png"), alt: "" },
          }),
          _c(
            "el-descriptions",
            { attrs: { column: "4" } },
            [
              _c("el-descriptions-item", { attrs: { label: "用户编号" } }, [
                _vm._v(_vm._s(_vm.baseUserInfoVo.userId)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "注册手机号" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.baseUserInfoVo.mobilePhone) +
                    "\n      "
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "uuid" } }, [
                _vm._v(_vm._s(_vm.baseUserInfoVo.uuid)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "注册时间" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.baseUserInfoVo.createTime) +
                    "\n      "
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "用户身份" } }, [
                _vm._v(_vm._s(_vm.userIdentity)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "用户来源" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.baseUserInfoVo.userSource) +
                    "\n      "
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "性别" } }, [
                _vm._v(_vm._s(_vm.userGender)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "生日" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.baseUserInfoVo.birthday) +
                    "\n      "
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "年龄" } }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.baseUserInfoVo.age) + "\n      "
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "地区" } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.baseUserInfoVo.cityName) +
                    "\n      "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "label-info" }, [
        _c(
          "div",
          { staticClass: "label-info-title" },
          [
            _c("span", [_vm._v("标签：")]),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "has-permi",
                    rawName: "v-has-permi",
                    value: ["user_edit"],
                    expression: "['user_edit']",
                  },
                ],
                attrs: { type: "text" },
                on: {
                  click: function ($event) {
                    return _vm.handleLabel(_vm.baseUserInfoVo)
                  },
                },
              },
              [_vm._v("编辑")]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "label-info-content" },
          _vm._l(_vm.baseUserInfoVo.tags, function (tag) {
            return _c(
              "el-tag",
              {
                key: tag.id,
                staticClass: "label-tag",
                attrs: { type: "info", effect: "plain" },
              },
              [_vm._v("\n        " + _vm._s(tag.tagName) + "\n      ")]
            )
          }),
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }